import { FlowchartLinkAttributeOperator } from '@treetop/shared/model';

export enum LinkValueInputType {
  Text = 'text',
  Number = 'number',
  Boolean = 'boolean',
  Table = 'table',
}

export interface LinkValueSelect {
  value: string;
  translationText: string;
  operator: FlowchartLinkAttributeOperator;
}

export interface MappedLinkValueType {
  selects: LinkValueSelect[];
  inputType: LinkValueInputType;
  payloadAttribute: string;
}
